import { render, staticRenderFns } from "./FancyTextarea.vue?vue&type=template&id=133c8d9c&scoped=true&"
import script from "./FancyTextarea.vue?vue&type=script&lang=js&"
export * from "./FancyTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FancyTextarea.vue?vue&type=style&index=0&id=133c8d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c8d9c",
  null
  
)

export default component.exports